var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',{staticClass:"app-footer__brand"},[_vm._v("Naprawa Online")])])
}]

export { render, staticRenderFns }